import { render, staticRenderFns } from "./artcle-detail.vue?vue&type=template&id=e9370586&scoped=true&"
import script from "./artcle-detail.vue?vue&type=script&lang=js&"
export * from "./artcle-detail.vue?vue&type=script&lang=js&"
import style0 from "./artcle-detail.vue?vue&type=style&index=0&id=e9370586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9370586",
  null
  
)

export default component.exports